import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { MediaZoom } from '@tribeplatform/react-ui-kit/MediaZoom';
import { BannerContent } from './BannerContent';
export const Banner = ({ banner, zoom = false, fallback, className, }) => {
    var _a, _b;
    if (!banner) {
        return (_jsx("div", { className: clsx('w-full overflow-hidden', className), children: fallback }, void 0));
    }
    if (!zoom) {
        return _jsx(BannerContent, { banner: banner, className: className }, void 0);
    }
    return (_jsx(MediaZoom, { zoom: true, children: _jsx(MediaZoom.Item, { item: {
                id: banner.id,
                thumbnail: (_a = banner.urls) === null || _a === void 0 ? void 0 : _a.large,
                original: (_b = banner.urls) === null || _b === void 0 ? void 0 : _b.large,
                alt: 'Cover',
            }, children: ({ open }) => (_jsx("button", { type: "button", onClick: open, className: "w-full block", children: _jsx(BannerContent, { banner: banner, className: className }, void 0) }, void 0)) }, void 0) }, void 0));
};
//# sourceMappingURL=Banner.js.map